// The guide's shared primitives: the code chip every view of a rule uses, the
// rank ordering that decides what "lightest first" means, and the comma list of
// codes the prose falls back to.
import React from "react";
import { Rule, chipInk, whiteBadgeFill } from "./api";
export function byRank(rules: Rule[]): Rule[] {
  return [...rules].sort((a, b) => a.rank - b.rank);
}
export function codes(rules: Rule[]): string {
  return rules.map((rule) => rule.code).join(", ");
}
export function Chip({
  rule,
  struck = false,
}: {
  rule: Rule;
  struck?: boolean;
}) {
  const fill = whiteBadgeFill(rule.color);
  return (
    <span
      className={`hk-clean-chip ${struck ? "hk-guide-struck" : ""}`}
      style={{ backgroundColor: fill, color: chipInk(fill) }}
    >
      {rule.code}
    </span>
  );
}
export function Chips({ rules, join }: { rules: Rule[]; join?: string }) {
  return (
    <>
      {rules.map((rule, index) => (
        <React.Fragment key={rule.id}>
          {index > 0 && join ? ` ${join} ` : null}
          <Chip rule={rule} />
        </React.Fragment>
      ))}
    </>
  );
}
